"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorCollectionButton = exports.TopologicalEditorButton = exports.CSS = void 0;
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var index_1 = require("../../i18n/index");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
function stopPropagation(e) {
    e.stopPropagation();
}
exports.CSS = {
    container: 'c-MapEditModeButton'
};
exports.TopologicalEditorButton = {
    view: function (tagId, center) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT_LOCATION, {
            title: index_1.T.LINK_MAP_MODE,
            href: page_1.IkePageName.topologicalEditor,
            hrefParams: {
                jobId: tagId,
                location: center
            },
            disabled: false,
            onclick: stopPropagation
        });
    }
};
exports.TopologicalEditorCollectionButton = {
    view: function (tagId, collectionUUID) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT_LOCATION, {
            className: exports.CSS.container,
            title: index_1.T.LINK_MAP_MODE,
            disabled: false,
            onclick: function (e) {
                services_1.Services.Window.confirmPageChange(e, services_1.Services.Route.getRouteURL(page_1.IkePageName.topologicalEditor, {
                    jobId: tagId,
                    collectionUUID: collectionUUID
                }));
            }
        });
    }
};
//# sourceMappingURL=topological.editor.button.js.map